import {findSubAccountByUuid} from '@/subaccount/subAccount.service'
import {CUSTOMER} from '@/subaccount/types/SubAccount'
import {newEntryLine, useTransactionCreator} from '@/transaction/create-transaction/TransactionCreator.service'
import {SubAccountLine} from '@/subaccount/outstandingBalance/SubAccountLine'
import {TransactionEntryLine} from '@/types/transaction/TransactionEntryLine'
import {CREATE_TRANSACTION} from '@/transaction/create-transaction'
import {usePanelManager} from '@tritt/multipanel'
import {useSetting} from '@/setting/setting.service'
import useDynamicTransactionFields from '@/transaction/create-transaction/transaction-fields.controller'

// TODO default payment account and default income account
export const useSubAccountLineService = () => {
    const {setPanelPath} = usePanelManager()
    const {transactionEntryLines, reset: resetCreate, updateIndices} = useTransactionCreator()
    const {selectedConfigKey} = useDynamicTransactionFields()
    const {setting: defaultIncomeAccount} = useSetting<string>('DEFAULT_INCOMING_PAYMENT_ACCOUNT')
    const {setting: defaultExpenseAccount} = useSetting<string>('DEFAULT_OUTGOING_PAYMENT_ACCOUNT')

    const handleCustomer = (subAccountLine: SubAccountLine, line: TransactionEntryLine) => {
        const incomeAccount = defaultIncomeAccount.value.value ?? defaultIncomeAccount.value.default ?? '1920'
        if (subAccountLine.remainingAmount > 0) {
            line.debitAccount = incomeAccount
            line.creditAccount = '1500'
            line.creditSubAccount = subAccountLine.subAccountUuid
        } else {
            line.debitAccount = '1500'
            line.debitSubAccount = subAccountLine.subAccountUuid
            line.creditAccount = incomeAccount
        }
    }

    const handleSupplier = (subAccountLine: SubAccountLine, line: TransactionEntryLine) => {
        const expenseAccount = defaultExpenseAccount.value.value ?? defaultExpenseAccount.value.default ?? '1920'
        if (subAccountLine.remainingAmount > 0) {
            line.debitAccount = expenseAccount
            line.creditSubAccount = subAccountLine.subAccountUuid
            line.creditAccount = '2400'
        } else {
            line.debitAccount = '2400'
            line.debitSubAccount = subAccountLine.subAccountUuid
            line.creditAccount = expenseAccount
        }
    }

    const paymentLineFromSubAccountLine = (subAccountLine: SubAccountLine) => {
        const subAccount = findSubAccountByUuid(subAccountLine.subAccountUuid)
        const line = newEntryLine()
        if (subAccount.relationType === CUSTOMER) {
            handleCustomer(subAccountLine, line)
        } else {
            handleSupplier(subAccountLine, line)
        }
        if (subAccountLine.dueDate) {
            line.date = new Date(subAccountLine.dueDate)
        }

        line.invoiceUuid = subAccountLine.invoiceUuid
        line.kid = subAccountLine.kid
        line.invoiceNo = subAccountLine.invoiceNo
        line.bban = subAccountLine.bankAccountNo || subAccount.bban || subAccount.iban
        line.amount = Math.abs(subAccountLine.remainingAmount)
        line.subAccountLines.push(subAccountLine.uuid)

        return line
    }

    const registerPayments = async (subAccountLines: SubAccountLine[], panelId: number) => {
        await setPanelPath({...CREATE_TRANSACTION, panelId}, false)
        resetCreate()
        selectedConfigKey.value = 'incomingVouchers'
        transactionEntryLines.value = [...subAccountLines.map(paymentLineFromSubAccountLine)]
        updateIndices()
    }

    return {
        registerPayments
    }
}
